import React, { useEffect, useState } from 'react';

import { checkMot } from '../../../../ressources/functionJS/checkMot';

import { getAllImportFilters } from 'services/api';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireSelectionImportFilter.module.scss';

const FormulaireSelectionImportFilter = (props) => {
  const [importFilterId, setImportFilterId] = useState(
    props.preconfigurerImportFilterId
  );
  const [selectedImportFilterId, setSelectedImportFilterId] =
    useState(undefined);

  const getImportFilters = async () => {
    try {
      const importFilters = await getAllImportFilters();
      if (importFilters.state) {
        setImportFilterId(importFilters.import_filters_list);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getImportFilters();
  }, [props.preconfigurerImportFilterId]);

  const gererImportFilterId = (event) => {
    /**
     * gère id du ImportFilter en fonction de l'option sélectionnée
     */
    setSelectedImportFilterId(event.target.value);
    props.gererImportFilterId(event.target.value);
  };
  return (
    <>
      <label
        className={[styles.stile].join(' ')}
        htmlFor="inlineFormCustomSelect"
      >
        {checkMot('importation_filtre_id')}
      </label>
      {importFilterId?.length > 0 ? (
        <select
          className={s.custom_select}
          onChange={gererImportFilterId}
          value={selectedImportFilterId || ''}
        >
          {!props.preconfigurerImportFilterId && (
            <option value="" disabled>
              {checkMot('selectionne_type_capteur')}
            </option>
          )}
          {importFilterId.map((filter) => (
            <option
              key={filter.import_filter_id}
              value={filter.import_filter_id}
            >
              {`id: ${filter.import_filter_id}, name: ${filter.import_filter_name}`}
            </option>
          ))}
        </select>
      ) : (
        <div>{checkMot('liste_capteur_pas_recupere_actuliser_page')}</div>
      )}
    </>
  );
};

export default FormulaireSelectionImportFilter;
